import { styled } from 'styled-components'

/**
 * Stands in for the grid at its full height, so the page does not jump when the
 * real one arrives.
 *
 * Two callers, and they must agree on that height: `ListView` shows this while
 * the grid's chunk downloads, and `ListViewTable` shows it (as `GridContainer`)
 * while it waits on accepted policies and the AG Grid licence.
 */
export const ListViewTableSkeleton = styled.div`
  height: 80vh;
  width: 100%;
`
